/* ============================================================
   "Drag to explore" line scrubber for the redesigned product page
   (templates/product.redesign.liquid). Decoupled from the theme's
   minified gallery code: it reads the active slide from Flickity's
   `is-selected` class and navigates by clicking the (hidden) thumbnail
   for the target slide — exactly like mobile-gallery-slider.js.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var galleries = document.querySelectorAll('.pdp-redesign .product-gallery');
    for (var i = 0; i < galleries.length; i++) setup(galleries[i]);
  }

  function setup(gallery) {
    if (gallery.__scrubInit) return;
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var items = [].slice
      .call(carousel.querySelectorAll('.product-gallery__carousel-item'))
      .filter(function (it) { return !it.classList.contains('is-filtered'); });
    if (items.length < 1) return;
    gallery.__scrubInit = true;

    var n = items.length;

    function mediaId(i) { return items[i].getAttribute('data-media-id'); }

    function caption(i) {
      if (i === 0) return 'The artwork';
      var img = items[i].querySelector('img');
      var alt = img && img.getAttribute('alt');
      if (alt && alt.charAt(0) !== '(' && alt.trim()) return alt.trim();
      return 'View ' + (i + 1);
    }

    function goTo(i) {
      i = Math.max(0, Math.min(n - 1, i));
      var t = gallery.querySelector(
        '.product-gallery__thumbnail[data-media-id="' + mediaId(i) + '"]'
      );
      if (t) t.click();
    }

    function currentIndex() {
      var sel = carousel.querySelector('.product-gallery__carousel-item.is-selected');
      var id = sel ? sel.getAttribute('data-media-id') : null;
      for (var i = 0; i < n; i++) { if (mediaId(i) === id) return i; }
      return 0;
    }

    // ---- build the scrubber DOM ----
    var wrap = document.createElement('div');
    wrap.className = 'scrub' + (n < 2 ? ' scrub--single' : '');

    var top = document.createElement('div');
    top.className = 'scrub__top';
    top.innerHTML =
      '<span class="scrub__hint">Drag to explore</span>' +
      '<span class="scrub__idx"></span>';

    var track = document.createElement('div');
    track.className = 'scrub__track';
    track.innerHTML = '<div class="scrub__line"></div><div class="scrub__fill"></div>';

    var tickEls = [];
    for (var i = 0; i < n; i++) {
      var tk = document.createElement('div');
      tk.className = 'scrub__tick';
      tk.style.left = (n > 1 ? (i / (n - 1) * 100) : 0) + '%';
      track.appendChild(tk);
      tickEls.push(tk);
    }
    var knob = document.createElement('div');
    knob.className = 'scrub__knob';
    track.appendChild(knob);

    var cap = document.createElement('div');
    cap.className = 'scrub__caption';

    wrap.appendChild(top);
    wrap.appendChild(track);
    wrap.appendChild(cap);

    var wrapper =
      gallery.querySelector('.product-gallery__carousel-wrapper') || carousel.parentNode;
    wrapper.parentNode.insertBefore(wrap, wrapper.nextSibling);

    var idxEl = top.querySelector('.scrub__idx');
    var fill = track.querySelector('.scrub__fill');

    function two(k) { return String(k).length < 2 ? '0' + k : '' + k; }

    function sync() {
      var idx = currentIndex();
      var pct = (n > 1 ? (idx / (n - 1) * 100) : 0) + '%';
      fill.style.width = pct;
      knob.style.left = pct;
      idxEl.textContent = two(idx + 1) + ' / ' + two(n);
      cap.textContent = caption(idx);
      for (var i = 0; i < n; i++) tickEls[i].classList.toggle('is-active', i === idx);
    }

    // ---- drag to scrub ----
    var dragging = false;
    function scrubFromX(clientX) {
      var r = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      goTo(Math.round(ratio * (n - 1)));
    }
    track.addEventListener('pointerdown', function (e) {
      if (n < 2) return;
      e.preventDefault();
      dragging = true;
      track.classList.add('is-grabbing');
      scrubFromX(e.clientX);
      var mv = function (ev) { if (dragging) scrubFromX(ev.clientX); };
      var up = function () {
        dragging = false;
        track.classList.remove('is-grabbing');
        window.removeEventListener('pointermove', mv);
        window.removeEventListener('pointerup', up);
      };
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', up);
    });

    if (typeof MutationObserver === 'function') {
      var ob = new MutationObserver(sync);
      for (var j = 0; j < n; j++) {
        ob.observe(items[j], { attributes: true, attributeFilter: ['class'] });
      }
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
